import { useState } from 'react';
import './News.css';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

interface NewsItem {
  id: string;
  date: string;
  content: string | JSX.Element;
  video?: {
    videoId: string;
    videoHash: string;
    facadeImage: string;
    videoTitle: string;
  };
  videoContent?: string | JSX.Element;
  socialLinks?: { platform: string; url: string; icon: string }[];
}

const News: React.FC = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState<{ [key: string]: boolean }>({});
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = parseInt(searchParams.get('page') || '1', 10);
  const itemsPerPage = 10;

  const handleFacadeClick = (newsId: string) => {
    setIsVideoLoaded((prev) => ({ ...prev, [newsId]: true }));
  };

  const newsItems: NewsItem[] = [
    // {
    //   id: '0666',
    //   date: '',
    //   content: (
    //     <>
    //       <Link to="/news/news12" className="yellow-underline" style={{ fontSize: '33px' }}>
    //         Творчество Сергея Мавроди
    //       </Link>
    //       <br />
    //       <br />
    //       <span className="yellow-underline">
    //         <a
    //           href="https://volga-kaspiy.ru/conflict/v-volzhskom-reshili-postavit-syna-lyutsifera-mavrodi.html/"
    //           style={{ fontSize: '21px', textDecorationColor: 'rgb(255, 205, 0)' }}
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           В Волжском решили поставить «Сына Люцифера» Мавроди
    //         </a>
    //       </span>
    //       <br />
    //       <br />
    //       <Link to="/news/news4" className="yellow-underline" style={{ fontSize: '33px' }}>
    //         Идея создания Театра Сергея Мавроди
    //       </Link>
          
    //     </>
    //   ),
    // },
    // {
    //   id: '0031',
    //   date: '24 Мая, 2025',
    //   content: (
    //     <>
    //       <p>Энтузиаст (0*2*4*0*8*) из ТСМ попросил (05.05.2025) Помощи у нашей Системы для осуществления ранее <a
    //           href="https://volga-kaspiy.ru/conflict/v-volzhskom-reshili-postavit-syna-lyutsifera-mavrodi.html/"
    //           style={{ textDecorationColor: 'rgb(0, 0, 0)' }}
    //           target="_blank"
    //           rel="noopener noreferrer"
    //         >
    //           Заявленного
    //         </a>.<br /> 
    //         Система незамедлительно Откликнулась и совершила безвозмездный Перевод на запрашиваемую Сумму.<br />
    //         Пусть всё Сбудется - Мы Можем Многое!
    //       </p>
    //       <hr />
    //       <img src="./images/news/555.webp" height="593" alt="Перевод из Газпрома" />
    //       <img src="./images/news/5.webp" width="593" alt="Перевод из Системы" />
    //     </>
    //   ),
    // },
    
    {
      id: '0030',
      date: '22 Мая, 2025',
      content: (
        <>
          <p>Буду тексты писать идеологические. И выкладывать периодически. :-))</p>
          <Link to="/ideology" className="yellow-underline" style={{ fontSize: '33px' }}>
            ИДЕОЛОГИЯ
          </Link>
          <br />
          <br />
          <p>
          Нет у меня никаких учеников. И слава богу. Только «учеников» мне ещё и не хватало! «Соучастие». Статья УК. Голимая. Для информации. Вам. А общий бизнес я вообще никогда не вёл. Ни с кем. Кстати, по МММ я ведь один проходил. Уникальный случай! Поскольку даже за бухгалтера сам везде расписывался. Чтобы никого не подставлять. Так что… <em>«Дальше всех уходит тот, кто в путь идёт один».</em> Так, кажется? Не помню только, чьё это стихотворение?.. Но не важно. Да. Таким вот образом.
          </p>
          <br />
          <hr />
          
          <Link to="/auslandsamt/post2" className="yellow-underline2">
            Английский вариант</Link>
          <br />
          <Link to="/ideology/kodex" className="yellow-underline2">
            КОДЕКС МММ-щика</Link>
          <br />
          <Link to="/schriftstellerei/lieder/lied40" className="yellow-underline2">
            Гимн МММ (Памяти активиста Системы Андрея Ким)</Link>
        </>
      ),
    },{
      id: '0029',
      date: '21 Мая, 2025',
      content: (
        <p>
          
            В связи с активной Регистрацией новых Пользователей - нам Временно ограничили некоторые функции системных Почтовых ящиков.<br/><br />
            По этой Причине - наблюдаются технические Проблемы при использовании Личных Кабинетов.<br /><br />
            Принимаются все необходимы Меры - Начальство в курсе текущей Ситуации.
            <br /><br />
            Администратор
          
          <hr />
          <br />
          <span>22 Мая, 2025 <br /><br />
            Восстановлены все функции системных Почтовых ящиков.<br /><br />
            Решены все технические Проблемы в ЛК.<br /><br />
            Сигнал был услышан!<br /><br />
            Администратор
          </span>
        </p>
      ),
    },{
      id: '0028',
      date: '20 Мая, 2025',
      content: (
        <>
          <Link to="/lk" className="yellow-underline" style={{ fontSize: '33px' }}>
            Познайте свою Удачу (только в ЛК)
          </Link>
          <br />
        </>
      ),
    },{
      id: '0027',
      date: '08 Мая, 2025',
      content: (
        <>
          <p>Называйте меня теперь так.</p>
          <Link to="/privacy" className="yellow-underline" style={{ fontSize: '33px' }}>
            ФЕНИКС
          </Link>
          <br />
          <br />
          <p>
          Канал общения со Вселенной открыт!!
          </p>
          <br />
          <hr />
          <p style={{textAlign: 'left'}}>«И говорит мне ангел: “Птица эта − хранитель вселенной. Летит она вместе с Солнцем и, раскинув крылья, принимает на себя лучи его, которые подобны языкам пламени.
          И если бы она не принимала их, не уцелел бы род человеческий, и вообще ничто живое”.<br />
          И сказал я: “Господин, как имя её?”<br />
          И сказал мне ангел: “Феникс имя её”».<br />
          <em>Апокриф. Апокалипсис, Откровение Варуха : 6</em></p>
        </>
      ),
    },{
      id: '0026',
      date: '01 Мая, 2025',
      content: (
        <>
          <p>Обновлённый раздел.</p>
          <Link to="/contacts" className="yellow-underline" style={{ fontSize: '33px' }}>
            КОНТАКТЫ
          </Link>
          <br />
          <br />
          <p>
          Руководитель не должен заниматься текучкой. Он вообще не должен ничем заниматься! Он должен отдыхать, ловить рыбу и обдумывать стратегические задачи. Если его присутствие необходимо в офисе − значит, дело плохо организовано.
          </p>
          <br />
          <hr />
        <p>P.S. И имейте в виду. Всё предварительно читает Администратор. Просто честно предупреждаю. Во избежание. :-))</p>
        </>
      ),
    },{
      id: '0025',
      date: '24 Апреля, 2025',
      content: (
        <>
          <p style={{ fontSize: '33px', textAlign: 'center' }}>МАРГАРИТА (13.09.2024)</p>
        </>
      ),
      video: {
        videoId: '1077519327',
        videoHash: 'fb268dbce7',
        facadeImage: '/images/KTL/Margo.avif',
        videoTitle: 'МАРГАРИТА / Сергей Мавроди',
      },
      videoContent: 'Завершено обновление раздела KinoTheater.',
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },{
      id: '0024',
      date: '20 Апреля, 2025',
      content: (
        <>
          <p style={{ fontSize: '33px', textAlign: 'center' }}>ЕСТЬ ЛЮДИ - ИЗ МЕДИ... (30.07.2024)</p>
        </>
      ),
      video: {
        videoId: '1076876105',
        videoHash: '2a2b467ac5',
        facadeImage: '/images/KTL/LedMed.avif',
        videoTitle: 'ЕСТЬ ЛЮДИ - ИЗ МЕДИ... / Сергей Мавроди',
      },
      videoContent: '– Господи! Вам всё кажется, что самое интересное в этой жизни − зарабатывать деньги. Уверяю вас, это не так. Повторяю, сейчас мне интересно заниматься творчеством. Меня это полностью занимает. Надеюсь, так оно будет и впредь. По крайней мере, в ближайшие сто лет. Если совсем уж край с деньгами наступит и жрать будет нечего − ну, придётся тогда «подзаработать», конечно. Но − не хотелось бы. Вот ей-богу! Надеюсь, до этого дело всё же не дойдёт. Твёрдо уповаю. Ибо мало − я не умею зарабатывать, а много − к катаклизмам всё время вселенским почему-то приводит. Совершенно немыслимым, причём. Каким-то волшебным образом так всё всегда оборачивается. Потом выпутываться ещё приходится. Тьфу, короче!',
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },{
      id: '0023',
      date: '12 Апреля, 2025',
      content: (
        <>
          <p style={{ fontSize: '33px', textAlign: 'center' }}>АНГЕЛ</p>
        </>
      ),
      video: {
        videoId: '1072614166',
        videoHash: 'c23010f077',
        facadeImage: '/images/KTL/Angel.avif',
        videoTitle: 'АНГЕЛ / Сергей Мавроди',
      },
      videoContent: 'Первый мультипликационный Фильм на стихи Сергея Мавроди. (18.04.2023)',
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0022',
      date: '01 Апреля, 2025',
      content: (
        <>
          <p>Иностранный отдел</p>
          <Link to="/auslandsamt" className="yellow-underline" style={{ fontSize: '33px' }}>
            AUSLANDSAMT
          </Link>
          <br />
          <br />
          <p>
            Патриот ли я? А что это вообще такое? Патриотизм? Вот раньше был СССР. Вы, как патриот, обязаны были любить и Украину, и Грузию… и Латвию, и Эстонию… А теперь вы, как патриот, что их обязаны? Ненавидеть? А завтра они, скажем, опять к нам присоединятся. (Ну, вдруг!) И вы их опять сразу же полюбите? Как-то всё это странно. И подозрительно. Когда люди (патриоты) с такой лёгкостью неимоверной свои убежденья и любови меняют. Как перчатки.
          </p>
          <br />
          <hr />
          <Link to="/auslandsamt/post1" className="yellow-underline2">
            Сын Люцифера — День 1, Игра (Deutsch)
          </Link>
        </>
      ),
    },
    {
      id: '0021',
      date: '26 Марта, 2025',
      content: (
        <>
          <p>Этап — 6. Сделка между ТСМ и КТL. (01.06.2021)</p>
          <Link to="/kinotheater/sohnluzifers/ktltag1" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 1, Игра
          </Link>
          <br />
          <br />
          <p>
            В городе Анапа готовился Гастрольный показ Спектакля "Игра".
            <br />
            <br />
            Между уполномоченными Представителями заключён Уговор:
            <br />
            КТL - осуществляет финансирование ТСМ крупной Суммой.
            <br />
            КТL - получает 33% чистой Прибыли от деятельности ТСМ.
            <br />
            <br />
            P.S. Сделка была "подписана" деловым Рукопожатием.
            <br />
            <br />
            P.P.S. Приказ №333 от 30.01.24 - выполнен. Сделка признана Аннулированной.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0020',
      date: '22 Марта, 2025',
      content: (
        <>
          <p>Этап — 5. Самодеятельность КиноТеатра LUZIFER. (20.12.2020)</p>
          <Link to="/kinotheater/sohnluzifers/ktltag83" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 83, Писатель
          </Link>
          <br />
          <br />
          <Link to="/kinotheater/sohnluzifers/ktltag37" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 37, Подарок
          </Link>
          <br />
          <br />
          <Link to="/kinotheater/sohnluzifers/ktltag38" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 38, Шантаж
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - организовал полный Выпуск трёх Экранизаций (Самостоятельно и без какой-либо Помощи), в том числе профинансировал все Направления (режиссёрское, рекламное, юридическое и другие).
            <br />
            <br />
            P.S. Для показа Фильмов и Спектаклей создано Юридическое лицо.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0019',
      date: '17 Марта, 2025',
      content: (
        <>
          <p>Этап — 4. Корона и КиноТеатр LUZIFER. (09.05.2020)</p>
          <Link to="/kinotheater/sohnluzifers/ktltag9" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера — День 9, Интервью
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - на должность Режиссёра профинансировал и провёл{' '}
            <Link to="/news/news19" className="yellow-underline1">
              КАСТИНГ.
            </Link>
            <br />
            <br />
            В следствие этого, Энтузиасты Творчества Сергея Мавроди совместно с Режиссёром и КиноТеатром - создали уникальную Экранизацию.
            <br />
            <br />
            КиноТеатр - организовал и оплатил рекламную Компанию для премьерного Показа онлайн Спектакля в условиях Пандемии.
            <br />
            <br />
            P.S. Этот творческий Союз ознаменовал появление Театра Сергея Мавроди.
            <Link to="/news/news4" className="yellow-underline2">
              (Идея создания Театра Сергея Мавроди)
            </Link>
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0018',
      date: '10 Марта, 2025',
      content: (
        <>
          <p>Чтобы побеждать, надо уметь − и отступать.</p>
          <img src="./images/news/0018.webp" width="593" height="174" alt="Масштаб личности Сергея Мавроди" />
          <br />
          <br />
          <p>Масштаб личности определяется лишь масштабом её деяний.</p>
          <br />
          <hr />
          <p>
            С 2007 по 2017 год Хамовнический суд вынес более 200 исполнительных листов в отношении Мавроди: общая сумма его долга составила 1,6 миллиарда рублей. Из них 219 тысяч рублей — долг по госпошлинам, а более 252 миллионов рублей — взыскания имущественного характера в пользу физических и юридических лиц.
          </p>
        </>
      ),
    },
    {
      id: '0017',
      date: '08 Марта, 2025',
      content: (
        <>
          <p>Этап — 3. Первая "неудача" КиноТеатра LUZIFER. (20.05.2018)</p>
          <span className="yellow-underline">
            <a
              href="https://volga-kaspiy.ru/conflict/v-volzhskom-reshili-postavit-syna-lyutsifera-mavrodi.html/"
              style={{ fontSize: '21px', textDecorationColor: 'rgb(255, 205, 0)' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              В Волжском решили поставить «Сына Люцифера» Мавроди
            </a>
          </span>
          <br />
          <br />
          <p>
            КиноТеатр совместно с Энтузиастами Творчества Сергея Мавроди - предпринял "попытку" осуществления Спектакля "Игра" на Сцене города Волжский.
            <br />
            <br />
            P.S. КиноТеатр - возместил затраченные Финансовые средства на Организацию.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0016',
      date: '03 Марта, 2025',
      content: (
        <>
          <p>Этап — 2. Явление и Первый шаг КиноТеатра LUZIFER. (10.02.2018)</p>
          <Link to="/kinotheater/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера (экранизация)
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - организовал и Полностью профинансировал Выпуск первого АудиоСпектакля в ВидеоФормате.
            <br />
            КиноТеатр - организовал и Полностью профинансировал Выпуск первой Экранизации.
            <br />
            Представители КиноТеатра - приняли личное участие в Съёмках.
            <br />
            <br />
            P.S. Создано при Участии - Энтузиастов Творчества Сергея Мавроди.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0015',
      date: '01 Марта, 2025',
      content: (
        <>
          <p>Этап — 1. Зарождение КиноТеатра LUZIFER. (05.09.2015)</p>
          <Link to="/kinotheater/zombi" className="yellow-underline" style={{ fontSize: '33px' }}>
            ZОМБИ
          </Link>
          <br />
          <br />
          <p>
            КиноТеатр - осуществил Хорошую финансовую Помощь на развитие Сериала.
            <br />
            КиноТеатр - организовал Локацию для первой Серии в городе Волжский.
            <br />
            Представитель КиноТеатра - принял личное участие в Съёмках.
          </p>
        </>
      ),
      socialLinks: [
        { platform: 'VK', url: 'https://vk.com/theatermavrodi', icon: '/images/v1.webp' },
        { platform: 'Facebook', url: 'https://www.facebook.com/profile.php?id=100056900434020', icon: '/images/f2.webp' },
        { platform: 'YouTube', url: 'https://www.youtube.com/channel/UCxq5hrk1N1pZ8_Xmkv4xKLg', icon: '/images/y3.webp' },
        { platform: 'RuTube', url: 'https://rutube.ru/channel/39271788/', icon: '/images/r4.webp' },
      ],
    },
    {
      id: '0014',
      date: '23 Февраля, 2025',
      content: (
        <p>
          <span className="zolt">
            Так, ну что...
            <br />
            Нужно следовать за Звездой.
            <br />
            Скоро - обновление раздела KinoTheater.
          </span>
        </p>
      ),
      video: {
        videoId: '1058204133',
        videoHash: '131bf8b157',
        facadeImage: '/images/news/N14.avif',
        videoTitle: 'СНЕГ / Сергей Мавроди',
      },
    },
    {
      id: '0013',
      date: '19 Февраля, 2025',
      content: (
        <>
          <p>Всё очень просто. Мёртвые почуяли живого.</p>
          <Link to="/schriftstellerei/woche" className="yellow-underline" style={{ fontSize: '33px' }}>
            Неделька
          </Link>
          <br />
          <br />
          <p>Любые вопросы в наш век всевозможных коммуникаций решить можно по телефону, и мое личное присутствие, таким образом, — сплошные понты.</p>
          <br />
          <hr />
          <span>
            Читайте подборку самых смешных и забавных стихотворений газеты в разделах{' '}
            <a href="https://sergey-mavrodi.com/schriftstellerei/woche/zeitung111" style={{ textUnderlineOffset: '5px', textDecorationColor: 'rgb(255, 205, 0)' }}>
              Журнал (Сатира и юмор)
            </a>{' '}
            и{' '}
            <a href="https://sergey-mavrodi.com/schriftstellerei/woche/zeitung333" style={{ textUnderlineOffset: '5px', textDecorationColor: 'rgb(255, 205, 0)' }}>
              Журнал (Переделка песен)
            </a>.
          </span>
        </>
      ),
    },
    {
      id: '0012',
      date: '11 Февраля, 2025',
      content: (
        <>
          <p>Существует только первое место. И − все остальные.</p>
          <img src="./images/news/1102.webp" style={{ width: '593px', height: 'auto' }} />
          <p>
            Заниматься литературным творчеством мне нравится. Поэтому я им и занимаюсь. Я, кстати, считаю (знаю!), что мой литературный дар уж не ниже по крайней мере моего финансового. Так что советую почитать. Настоятельно рекомендую! Не пожалеете! Много нового и неожиданного о себе узнаете.
          </p>
          <br />
          <hr />
          <div className="yellow-underline2" style={{ textAlign: 'center', marginBottom: '13px' }}>
            <a href="https://sergeymavrodi.narod.ru/" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
              https://sergeymavrodi.narod.ru/
            </a>
          </div>
          <div className="yellow-underline2" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <a href="https://proza.ru/avtor/mavrodi" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
              https://proza.ru/avtor/mavrodi
            </a>
            <a href="https://stihi.ru/avtor/sergeymavrodi" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
              https://stihi.ru/avtor/sergeymavrodi
            </a>
          </div>
        </>
      ),
    },
    {
      id: '0011',
      date: '30 Января, 2025',
      content: (
        <>
          <p>Колебаться надо лишь при выборе цели. Далее надо просто действовать.</p>
          <Link to="/schriftstellerei/lieder" className="yellow-underline" style={{ fontSize: '33px' }}>
            Песни
          </Link>
          <br />
          <br />
          <p>Я ничего не читаю, не слушаю и не смотрю. А также, по возможности, ни с кем не общаюсь. Меня вполне устраивает собственное общество. И терпеть не могу события! Это они меня просто обожают.</p>
          <br />
          <hr />
          <Link to="/schriftstellerei/lieder/lied4" className="yellow-underline2">
            Цикл песен "Ромео и Джульетта"
          </Link>
        </>
      ),
    },
    {
      id: '0010',
      date: '27 Января, 2025',
      content: (
        <>
          <p>Всегда стоишь перед выбором: остановиться или идти дальше? И всегда идёшь дальше, хотя следовало бы остановиться. Но остановиться − невозможно.</p>
          <Link to="/schriftstellerei/drehbuch" className="yellow-underline" style={{ fontSize: '33px' }}>
            Киносценарии
          </Link>
          <br />
          <br />
          <p>
            Изумрудная оса. Знаете, в тропиках живёт? Жалит таракана в мозг, в результате чего тот теряет способность принимать самостоятельные решения. После чего берёт его за усы (за рога!) и ведёт к себе в нору (в стойло!). Где откладывает в него яйца. Вылупившиеся личинки пожирают бедного таракана заживо. Вот так же и женщина. Жалит постоянно. На ментальном уровне. Это у неё инстинктивно. Самой природой заложено. Самка! Сопротивляться невозможно. Физиология. Поэтому нельзя встречаться слишком часто. С одной и той же. Яда слишком много в крови накапливается. Впрочем, рано или поздно всё равно ошибаешься. Природу не обманешь.
          </p>
          <br />
          <hr />
          <p>
            У меня не бывает свободного времени. В обычном понимании этого слова. Мне его всегда катастрофически не хватает. Сколько еще не написано, не сделано!.. Скажем, та же литература. Обычная проблема большинства авторов — отсутствие сюжетов. У меня же проблема прямо противоположная — их избыток! Они переполняют меня! Я не успеваю их записывать! А есть еще ведь и стихи, и сценарии к фильмам. Да и финансовый апокалипсис, мать его! Надо все же доделать. Раз обещал. Время, время!
          </p>
        </>
      ),
    },
    {
      id: '0009',
      date: '24 Января, 2025',
      content: (
        <>
          <p>Свобода − это как возможность дышать.</p>
          <Link to="/schriftstellerei/gefangnis" className="yellow-underline" style={{ fontSize: '33px' }}>
            Тюрьма
          </Link>
          <br />
          <br />
          <p>
            Тюрьма это как свалка. Всё гниёт. Не гниют в этом мире, как известно, только благородные металлы. Золото, платина, серебро. Вот если у вас есть в душе что-то из золота, платины или серебра, это останется. Остальное же… Увы! Ну, если вы, конечно, весь из одних только благородных металлов состоите, то вам никакая тюрьма не страшна. Остальным же − не рекомендуется. Гниль − останется.
          </p>
          <br />
          <hr />
          <Link to="/schriftstellerei/gefangnis/zweiundvierzig" className="yellow-underline42" style={{ textDecorationColor: 'rgb(255, 205, 0)' }}>
            42
          </Link>
        </>
      ),
    },
    {
      id: '0008',
      date: '20 Января, 2025',
      content: (
        <>
          <p>Я не гений. Я — единственный!</p>
          <Link to="/schriftstellerei/tagebucher" className="yellow-underline" style={{ fontSize: '33px' }}>
            Дневники Сына Люцифера
          </Link>
          <br />
          <br />
          <p>
            У меня присутствует совершенно ясное и чёткое внутреннее… убеждение?.. ощущение?.. что никто, никто! в целом свете не может меня ни искушать, ни соблазнять, ни вообще как-то на меня влиять и воздействовать. НИКТО! Ни Бог, ни Дьявол. Я сам делаю всегда свой выбор. Я и только я!
          </p>
          <br />
          <hr />
          <p>Люцифер (Lucifer – «несущий свет», «утренняя звезда», «денница» лат.)</p>
        </>
      ),
    },
    {
      id: '0007',
      date: '17 Января, 2025',
      content: (
        <div style={{ textAlign: 'center' }}>
          <Link to="/schriftstellerei/gedichte" className="yellow-underline" style={{ fontSize: '33px' }}>Мои стихи</Link>
          <br />
          <br />
          <p style={{ textAlign: 'center' }}>
            Все пишут спокойно, а я – задыхаясь!
            <br />
            От гнева и боли
            <br />
            На стоны срываясь.
            <br />
            А я – поневоле!
            <br />
            Тоскуя и маясь.
            <br />
            От страха и боли
            <br />
            Боясь задохнуться.
            <br />
            Заснуть – не проснуться.
            <br />
            Уйти – не вернуться.
            <br />
            И не обернуться.
          </p>
        </div>
      ),
    },
    {
      id: '0006',
      date: '13 Января, 2025',
      content: (
        <>
          <p>
            Более великой книги, чем «Сын Люцифера» − не существует. <br />
            Если люди пока этого не понимают − тем хуже для них.
          </p>
          <Link to="/schriftstellerei/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>
            Сын Люцифера
          </Link>
          <br />
          <br />
          <p>
            Это роман. Состоит он из отдельных, независимых новелл–дней, в которых Люцифер показывает Своему Сыну на конкретных жизненных примерах все человеческие пороки. Ставя обычных, простых людей в необычные и непростые отнюдь ситуации, когда им приходится делать выбор. Искушая их! И искушений этих люди большей частью, увы, не выдерживают...
          </p>
          <br />
          <hr />
          <p>
            Роман опубликован целиком, без купюр и именно в авторской редакции.
            <br />
            Надеюсь, вам понравится. Да уверен просто! Приятного чтения. :–))
          </p>
        </>
      ),
    },
    {
      id: '0005',
      date: '01 Января, 2025',
      content: (
        <p>
          <span className="zolt">
            Так, ну что...
            <br />
            Нужно следовать за Звездой.
            <br />
            Скоро - обновление раздела Творчество.
          </span>
        </p>
      ),
    },
    {
      id: '0004',
      date: '25 Декабря, 2024',
      content: (
        <>
          <Link to="/news/news4" className="yellow-underline" style={{ fontSize: '33px' }}>
            Идея создания Театра Сергея Мавроди
          </Link>
          <br />
          <br />
        </>
      ),
    },
    {
      id: '0003',
      date: '19 Декабря, 2024',
      content: (
        <p>
          <span className="zolt">
            "Слухи о моей смерти сильно преувеличены."
            <br />
            <br />
            Цитата.
          </span>
        </p>
      ),
    },
    {
      id: '0002',
      date: '05 Августа, 2024',
      content: (
        <p>
          <span className="zolt">
            Зеркала сайта Сергея Мавроди:
            <br />
            <br />
            <a href="https://www.mavrodi-mmm-2011.com/" target="_blank" rel="noopener noreferrer">
              www.mavrodi-mmm-2011.com
            </a>
            <br />
            <br />
            <a href="https://www.sergey-mavrodi.ms/" target="_blank" rel="noopener noreferrer">
              www.sergey-mavrodi.ms
            </a>
          </span>
        </p>
      ),
    },
    {
      id: '0001',
      date: '29 Июля, 2024',
      content: (
        <p>
          <span className="zolt">
            Официальный сайт Сергея Мавроди -
            <br />
            функционирует Правильно!
          </span>
        </p>
      ),
    },
  ];

  const totalItems = newsItems.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentNews = newsItems.slice(startIndex, endIndex);

  const handlePageChange = (page: number) => {
    setSearchParams({ page: page.toString() });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const firstNewsOnPage = currentNews[0];
  const metaDescription = firstNewsOnPage
    ? typeof firstNewsOnPage.content === 'string'
      ? firstNewsOnPage.content.substring(0, 150) + '...'
      : Array.isArray(firstNewsOnPage.content.props.children)
        ? firstNewsOnPage.content.props.children
            .flat()
            .filter((child: React.ReactNode) => typeof child === 'string')
            .join(' ')
            .substring(0, 150) + '...'
        : String(firstNewsOnPage.content.props.children).substring(0, 150) + '...'
    : 'Читайте последние новости на Официальном сайте Сергея Мавроди.';

  return (
    <>
      <Helmet>
        <title>Новости - Официальный сайт Сергея Мавроди</title>
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content="Сергей Мавроди, МММ, новости, KinoTheater, творчество, театр, обновления" />
        <meta property="og:title" content="Новости - Официальный сайт Сергея Мавроди" />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content="/images/news/tki.webp" />
        <meta property="og:url" content={`https://www.sergey-mavrodi.com/news?page=${currentPage}`} />
        <meta property="og:type" content="article" />
        <link rel="canonical" href={`https://www.sergey-mavrodi.com/news?page=${currentPage}`} />
      </Helmet>
      <div>
        <div className="breadcrumbs">
          <div id="breadcrumb">
            <Link to="/">Главная страница</Link> → Новости
          </div>
        </div>
        <div className="content">
          <h2>НОВОСТИ</h2>
          <br />
          <hr />
          <br />
          {currentNews.map((news) => (
            <div className="news_block" key={news.id}>
              <div className="news_block_head">
                <div className="news_date">
                  <i></i>
                  <span>{news.date}</span>
                </div>
              </div>
              <div className="content_white_cloud">
                <div className="cwc_top"></div>
                <div className="cwc_mid">
                  <div className="news_item">
                    <div className="news_item_one">
                      <div className="liked liked-scope-true" data-liked-type="news" data-liked-id={news.id}></div>
                      <div className="anons">
                        <div>
                          <strong>{news.content}</strong>
                          {news.video && (
                            <div style={{ position: 'relative', paddingTop: '56.25%', width: '100%' }}>
                              {!isVideoLoaded[news.id] ? (
                                <div
                                  className="video-facade"
                                  onClick={() => handleFacadeClick(news.id)}
                                  role="button"
                                  tabIndex={0}
                                  onKeyDown={(e) => e.key === 'Enter' && handleFacadeClick(news.id)}
                                >
                                  <img
                                    src={news.video.facadeImage}
                                    alt={`Превью видео: ${news.video.videoTitle}`}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    loading="lazy"
                                  />
                                  <svg
                                    className="play-button"
                                    viewBox="0 0 24 24"
                                    fill="rgb(255, 131, 0)"
                                    role="button"
                                    aria-label={`Воспроизвести видео: ${news.video.videoTitle}`}
                                  >
                                    <path d="M8 5v14l11-7z" />
                                  </svg>
                                </div>
                              ) : (
                                <iframe
                                  src={`https://player.vimeo.com/video/${news.video.videoId}?h=${news.video.videoHash}&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1`}
                                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}
                                  title={news.video.videoTitle}
                                  sandbox="allow-same-origin allow-scripts allow-presentation"
                                />
                              )}
                            </div>
                          )}
                          <br />{news.videoContent && (
  <p style={{ textAlign: ['0023', '0025'].includes(news.id) ? 'center' : 'left' }}>
    <strong>{news.videoContent}</strong>
  </p>
)}
                          {news.socialLinks && (
                            <>
                              <hr />
                              <div className="social-links">
                                {news.socialLinks.map((link) => (
                                  <a
                                    key={link.platform}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title={`Перейти на ${link.platform}`}
                                  >
                                    <img src={link.icon} alt={link.platform} width="30" height="30" style={{ marginLeft: '20px' }} />
                                  </a>
                                ))}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cwc_bot"></div>
              </div>
            </div>
          ))}
          {totalPages > 1 && (
            <div className="paginator">
              <ul>
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    aria-label="Предыдущая страница"
                  >
                    {'<<<'}
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
                  <li key={page} className={currentPage === page ? 'active' : ''}>
                    <button onClick={() => handlePageChange(page)} aria-label={`Страница ${page}`}>
                      {page}
                    </button>
                  </li>
                ))}
                <li>
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    aria-label="Следующая страница"
                  >
                    {'>>>'}
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default News;